import React, { useState, useEffect, Component } from 'react';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-quartz.css';
import { AgGridReact } from 'ag-grid-react';
import { useNavigate } from 'react-router-dom';
import ApiService from '../../services/apiService';
import Select from 'react-select';
import { RiRefreshLine } from 'react-icons/ri';
import { FaAngleLeft } from 'react-icons/fa6';
import { FaSave } from 'react-icons/fa';
import Pagination from '../pagination/pagination';
import { hasPermission } from '../../services/roleService';
import { useSelector } from 'react-redux';
import { getName } from '../../../Redux/selecters';
import moment from 'moment';
import { toast } from 'react-toastify';
import Modal from 'react-bootstrap/Modal';
import AsyncSelect from 'react-select/async';
import { ClipLoader } from 'react-spinners';
import { useCurrency } from '../../../INVENTORY/Layouts/currencyContext';

const Posting = () => {
  const [rowData, setRowData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [postedData, setPostedData] = useState(null);
  const [selectedPost, setSelectedPost] = useState();
  const [modalData, setModalData] = useState([]);
  const [accounts, setAccounts] = useState([]);
  const [page, setPage] = useState(1);
  const [hasMore, setHasMore] = useState(true);
  const [loader, setLoader] = useState(false);
  const { currencyPrecision } = useCurrency();
  const [DocTerm, setDocTerm] = useState({ value: 'Doc Type', label: 'Doc Type' });
  const [pageSize, setPageSize] = useState(20);
  const [permissions, setPermissions] = useState([]);
  const [pagination, setPagination] = useState({ currentPage: 1, totalPages: 1 });
  const userName = useSelector(getName);
  const [GlModal, setGlModal] = useState(false);
  const onOpenModal = () => setGlModal(true);
  const onCloseModal = () => setGlModal(false);
  const [searchLoader, setLoad] = useState(false);
  const apiService = new ApiService();
  const currentDatetimeUTC = new Date().toISOString();
  const todayDate = new Date().toISOString().substr(0, 10);
  let navigate = useNavigate();
  const DocFilter = [
    { value: 'GRN', label: 'GRN' },
    { value: 'Invoice', label: 'Invoice' },
    { value: 'Purchase Return', label: 'Purchase Return' },
    { value: 'Issue', label: 'Issue item' },
    { value: 'Issue Return', label: 'Issue Return' },
    { value: 'Adjustment', label: 'Stock Adjustment' },
  ];
  const [formData, setFormData] = useState({
    DocNo: '',
    RefNo: '',
    AmountFrom: '',
    AmountTo: '',
    fromDate: '',
    toDate: '',
  });
  useEffect(() => {
    const storedPermissions = JSON.parse(localStorage.getItem('RoleAccess')) || [];
    const permissions = storedPermissions?.filter((acc) => acc.formName === 'Posting');
    setPermissions(permissions[0]);
  }, []);
  const getItems = async (pageNo) => {
    pageNo = pageNo || 1;
    try {
      setLoad(true)
      const params = new URLSearchParams();
      const defaultFromDate = moment().subtract(1, 'months').format('DD-MMM-YY');
      const defaultToDate = moment().add(1, 'months').format('DD-MMM-YY');
      const fromDate = formData.fromDate ? moment(formData.fromDate).format('DD-MMM-YYYY') : defaultFromDate;
      const toDate = formData.toDate ? moment(formData.toDate).format('DD-MMM-YYYY') : defaultToDate;
      params.append('PageNo', pageNo?.button === 0 ? 1 : pageNo);
      params.append('PageSize', pageSize || 20);

      params.append('DocType', DocTerm.value);
      if (formData.DocNo) {
        params.append('DocNo', formData.DocNo || '');
      }
      params.append('From', fromDate);
      params.append('To', toDate);
      params.append('AmountFrom', formData.AmountFrom || 0);
      params.append('AmountTo', formData.AmountTo || 0);
      const res = await apiService.getApiParamater('GET_POSTING', `?${params.toString()}`);

      const sortedData = res?.data?.result?.sort((a, b) => {
        const dateA = moment(a.docdate, 'DD MMM YYYY');
        const dateB = moment(b.docdate, 'DD MMM YYYY');
        if (dateA.isAfter(dateB)) return -1;
        if (dateA.isBefore(dateB)) return 1;
        const docNoA = parseInt(a.docno.split('/')[1], 10);
        const docNoB = parseInt(b.docno.split('/')[1], 10);
        return docNoB - docNoA;
      });
      setPagination(res.data.paginationData);
      setRowData(sortedData || []);
      setLoad(false)
    } catch (error) {
      setLoad(false)
      console.error('Error fetching items:', error);
    }
  };
  const PostData = async (data) => {
    try {
      setLoading(true);
      setPostedData(data);
      const params = new URLSearchParams();
      params.append('DocType', data.doctype);
      params.append('DocNo', data.docno);
      const res = await apiService.getApiParamater('GET_GL_POSTING', `?${params.toString()}`);
      
      setSelectedPost(res.data.result);
      const requestBody = {
        docNo: data.docno,
        mode: data.doctype,
        user: userName,
      };
      const response = await apiService.post('CREATE_POSTING', requestBody);
      setLoading(false);
      
      if (response.data.statusCode === 201) {
        toast.success(response?.data?.message)
        getItems();
        setLoading(false);
      } else {
        toast.error(response?.data?.message)
        setLoading(false);
      }
    } catch (error) {
      console.error('Error fetching items:', error);
      toast.error(error?.response?.data?.message)
      setLoading(false);
    }
  };
  const handleGlChange = async (data) => {
    const params = new URLSearchParams();
    params.append('DocType', data.doctype);
    params.append('DocNo', data.docno);
    const res = await apiService.getApiParamater('GET_GL_ACC_POST', `?${params.toString()}`);
    const filteredData = res?.data?.result?.filter((row) => row.debit > 0);
    setModalData(filteredData?.reverse());
    onOpenModal();
  };
  const Comparison = [
    { headerName: 'Doc Type', field: 'doctype', suppressMovable: true, width: 170 },
    { headerName: 'Doc No', field: 'docno', suppressMovable: true, width: 170 },
    { headerName: 'Ref No', field: 'refno', suppressMovable: true, width: 170 },
    { headerName: 'Doc Date', field: 'docdate', suppressMovable: true, width: 170 },
    { headerName: 'Invoice No', field: 'invoiceno', suppressMovable: true, width: 150 },
    { headerName: 'Invoice Ref', field: 'invoiceref', suppressMovable: true, width: 150 },
    { headerName: 'Currency Code', field: 'currCode', suppressMovable: true, width: 150 },
    { headerName: 'Amount', field: 'amount', suppressMovable: true, width: 150 },
    {
      headerName: 'Change GL',
      field: 'status',
      suppressMovable: true,
      width: 150,
      cellRenderer: function (params) {
        return (
          <>
            {['Purchase Return', 'Adjustment', 'Issue Return'].includes(params?.data?.doctype) ? (
              ''
            ) : (
              <button style={{ color: '#1032E7', textDecoration: 'underline' }} onClick={() => handleGlChange(params?.data)} class="btn">
                Change GL
              </button>
            )}
          </>
        );
      },
    },
    {
      headerName: 'Action',
      field: 'id',
      cellRenderer: PrinterBtn,
      cellRendererParams: {
        PostData: PostData,
        permissions: permissions,
        loading: loading,
        postedData: postedData,
        clicked: function (field) {
          // handleShow(field)
        },
      },
      suppressMovable: true,
      width: 150,
    },
  ];
  const handleBackClick = () => {
    window.history.back();
  };
  const handleReset = () => {
    setFormData({
      DocNo: '',
      RefNo: '',
      AmountFrom: '',
      AmountTo: '',
      fromDate: todayDate,
      toDate: todayDate,
    });
    setDocTerm({ value: 'Doc Type', label: 'Doc Type' });
  };
  const handleDocFilter = (selectedOption) => {
    localStorage.setItem('selectedOptionLabel', selectedOption.label);
    setDocTerm(selectedOption);
  };
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    if (name === 'fromDate' || name === 'toDate') {
      const dateParts = e.target.value.split('-');
      if (dateParts[0].length > 4) {
        return;
      }
    }
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };
  const onCellClicked = async (event) => {
    if (event.colDef.field === 'docno' || 'refno' || 'doctype' || 'docdate' || 'invoiceno' || 'currCode' || 'amount') {
      const clickedRowData = event.data;
      const params = new URLSearchParams();
      params.append('DocType', clickedRowData.doctype);
      params.append('DocNo', clickedRowData.docno);

      const res = await apiService.getApiParamater('GET_GL_POSTING', `?${params.toString()}`);
      setSelectedPost(res.data.result);
    }
  };
  const handleCGSAccountChange = (selectedOption, index) => {
    const updatedData = modalData.map((row, i) =>
      i === index
        ? {
          ...row,
          accountName: selectedOption.label,
          accountCode: selectedOption.value.accountCode,
        }
        : row,
    );
    setModalData(updatedData);
  };
  const loadOptions = async (inputValue, callback) => {
    const options = await fetchAccountData(inputValue, 1);
    callback(options);
  };
  const loadMoreOptions = async () => {
    if (!hasMore || loader) return;
    setPage((prevPage) => prevPage + 1);
    await fetchAccountData('', page + 1);
  };
  useEffect(() => {
    fetchAccountData('', 1);
  }, []);
  const fetchAccountData = async (inputValue = '', pageNumber = 1) => {
    if (loader) return;
    setLoader(true);
    try {
      const apiService = new ApiService();
      const params = new URLSearchParams();
      params.append('PageNo', pageNumber || 1);
      params.append('PageSize', 20);
      params.append('AccountName', inputValue || '');
      const response = await apiService.getApiParamater('GET_ACCOUNTS', `?${params.toString()}`);
      const fetchedAccounts = response.data.result.map((account) => ({
        label: account.accountName,
        value: account,
      }));
      if (fetchedAccounts.length < 20) setHasMore(false);
      setAccounts((prevAccounts) => [...prevAccounts, ...fetchedAccounts]);
      setLoader(false);
      return fetchedAccounts;
    } catch (error) {
      console.error('Error fetching account data:', error);
      setLoader(false);
      return [];
    }
  };
  const UpdatePost = async () => {
    try {
      for (const item of modalData) {
        const param = {
          docNo: item.docNo,
          inventoryAccountName: item.accountName,
          inventoryAccountCode: item.accountCode,
          srno: item.srno,
          itemCode: item.itemCode,
          docType: DocTerm.value,
        };
        const res = await apiService.put('UPDATE_GL_ACC_POST', param);
        if (res.data.statusCode === 200 || 201) {
          const params = new URLSearchParams();
          params.append('DocType', DocTerm.value);
          params.append('DocNo', item.docno);
          const GlRes = await apiService.getApiParamater('GET_GL_POSTING', `?${params.toString()}`);
          setSelectedPost(GlRes.data.result);
          onCloseModal();
        } else {
          toast.error(res?.data?.message)
        }
      }
    } catch (error) {
      console.error('Update Error:', error);
    }
  };
  return (
    <div className="px-4 pb-5">
      <div className="border-box2 p-4 mt-4">
        <div className=" d-flex justify-content-between">
          <h5 className="col mainInvHead">Posting</h5>
          <div className="d-flex gap-3">
            {searchLoader === true ?
              <button className='mainbtnGry w-100' type="submit"><ClipLoader color="#ffffff" size={25} /></button> :
              <button className="mainbtnGry " type="submit" onClick={getItems}>
                <FaSave className="center mt-1 mx-2" />
                <div>Search</div>
              </button>
            }
            <button className="mainbtnRed" onClick={handleReset}>
              <RiRefreshLine className="center mt-1 mx-2" />
              <div>Reset</div>
            </button>
            <button onClick={handleBackClick} className="mainbtn">
              <FaAngleLeft className="center mt-1 mx-2" />
              <div>Back</div>
            </button>
          </div>
        </div>
        <div className="row d-flex justify-content-between py-3 mt-4">
          <div className="col">
            <Select
              value={DocTerm}
              options={DocFilter}
              onChange={handleDocFilter}
              className=" p-0"
              theme={(theme) => ({
                ...theme,
                borderRadius: 5,
                padding: 9,
              })}
              menuPortalTarget={document.body}
              styles={{
                menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                option: (provided, state) => ({
                  ...provided,
                  backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                  color: state.isFocused ? '#000 ' : '#000',
                  ':hover': {
                    backgroundColor: '#F5F5F5',
                    color: '#000 ',
                  },
                }),
              }}
            />
          </div>
          <div className="col">
            <input
              type="date"
              className="form-Input"
              name="fromDate"
              placeholder="from Date"
              value={formData?.fromDate || moment().subtract(1, 'months').format('YYYY-MM-DD')}
              onChange={handleInputChange}
            />
          </div>
          <div className="col">
            <input type="date" className="form-Input" name="toDate" placeholder="To Date" value={formData?.toDate || todayDate} onChange={handleInputChange} />
          </div>
          <div className="col">
            <input type="text" className="form-Input" name="DocNo" placeholder="Doc No" value={formData?.DocNo} onChange={handleInputChange} />
          </div>
          .
          <div className="col">
            <input type="number" className="form-Input" name="AmountFrom" placeholder="Amount From" value={formData?.AmountFrom} onChange={handleInputChange} />
          </div>
          <div className="col">
            <input type="number" className="form-Input" name="AmountTo" placeholder="Amount To" value={formData?.AmountTo} onChange={handleInputChange} />
          </div>
        </div>
      </div>

      <div className="gridshad mt-3">
        <div className="ag-theme-quartz" style={{ height: 500 }}>
          <AgGridReact
            getRowStyle={(params) => {
              if (params.node.rowIndex % 2 === 0) {
                return { background: '#F0EDF5' };
              } else {
                return { background: '#fff' };
              }
            }}
            rowData={rowData}
            columnDefs={Comparison}
            pagination={false}
            rowSelection={'single'}
            suppressExcelExport={true}
            suppressRowClickSelection={true}
            onCellClicked={onCellClicked}
          />
        </div>
        <Pagination pageSize={pageSize} setPageSize={setPageSize} pagination={pagination} getItems={getItems} />
      </div>
      <div className="gridshad mt-5">
        <div className="row p-2 p-0 m-0" style={{ backgroundColor: '#6E5199', color: '#fff', fontWeight: 500 }}>
          <div className="col-2">Account Code</div>
          <div className="col-2">Date</div>
          <div className="col-2">Account Name</div>
          <div className="col-2">Cost Center 1</div>
          <div className="col-2">Cost Center 2</div>
          <div className="col-1">Debit</div>
          <div className="col-1">Credit</div>
        </div>
        {selectedPost?.map((row, index) => (
          <div className="row p-2 p-0 m-0">
            <div className="col-2">{row?.accountCode}</div>
            <div className="col-2">{moment(currentDatetimeUTC).format('DD-MMM-YYYY')}</div>
            <div className="col-2">{row?.accountName}</div>
            <div className="col-2">{row?.costCenter1 || '---'}</div>
            <div className="col-2">{row?.costCenter2 || '---'}</div>
            <div className="col-1">{row?.debit}</div>
            <div className="col-1">{row?.credit}</div>
          </div>
        ))}
      </div>
      <Modal
        size="xl"
        className="change-gl-modal-wrapper"
        dialogClassName="change-gl-modal"
        contentClassName="change-gl-modal-content"
        show={GlModal}
        onHide={onCloseModal}
        centered
      >
        <Modal.Header closeButton className="change-gl-modal-header">
          <Modal.Title className="w-100 text-center" style={{ fontSize: '1.25rem' }}>
            Change GL
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="change-gl-modal-body">
          <div className="change-gl-table-wrapper">
            <table className="dynoTable change-gl-table">
              <thead>
                <tr>
                  <th scope="col">Item code</th>
                  <th scope="col">Item Description</th>
                  <th scope="col">Specification</th>
                  <th scope="col">Acc Code</th>
                  <th scope="col">Acc Name</th>
                  <th scope="col">Debit</th>
                  <th scope="col">Credit</th>
                </tr>
              </thead>
              <tbody>
                {modalData?.map((row, index) => (
                  <tr key={index}>
                    <td className="m-0 p-1">
                      <input className="p-2 form-Input" disabled value={row.itemCode} style={{ width: '180px', fontSize: '14px' }} />
                    </td>
                    <td className="m-0 p-1">
                      <input className="p-2 form-Input" disabled value={row.itemDescription} style={{ width: '240px', fontSize: '14px' }} />
                    </td>
                    <td className="m-0 p-1">
                      <input className="p-2 form-Input" disabled value={row.specification} style={{ width: '200px', fontSize: '14px' }} />
                    </td>
                    <td className="m-0 p-1">
                      <input className="p-2 form-Input" disabled value={row.accountCode} style={{ width: '180px', fontSize: '14px' }} />
                    </td>
                    <td className="m-0 p-1">
                      <AsyncSelect
                        theme={(theme) => ({
                          ...theme,
                          borderRadius: 5,
                        })}
                        menuPortalTarget={document.body}
                        styles={{
                          control: (base) => ({
                            ...base,
                            minHeight: '42px',
                            fontSize: '14px',
                            width: '320px',
                          }),
                          menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                          option: (provided, state) => ({
                            ...provided,
                            backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                            color: state.isFocused ? '#000 ' : '#000',
                            fontSize: '14px',
                            padding: '10px 12px',
                            ':hover': {
                              backgroundColor: '#F5F5F5',
                              color: '#000 ',
                            },
                          }),
                        }}
                        className="p-0"
                        isDisabled={!permissions?.canAdd}
                        value={{ value: row.accountName, label: row.accountName }}
                        onChange={(selectedOption) => handleCGSAccountChange(selectedOption, index)}
                        loadOptions={loadOptions}
                        defaultOptions={accounts}
                        cacheOptions
                        onMenuScrollToBottom={loadMoreOptions}
                      />
                    </td>
                    <td className="m-0 p-1">
                      <input className="p-2 form-Input" disabled value={row.debit} style={{ width: '120px', fontSize: '14px' }} />
                    </td>
                    <td className="m-0 p-1">
                      <input className="p-2 form-Input" disabled value={row.credit} style={{ width: '120px', fontSize: '14px' }} />
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </Modal.Body>
        <Modal.Footer className="change-gl-modal-footer p-3">
          <button className="mainbtn" onClick={UpdatePost}>
            Update
          </button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};
class PrinterBtn extends Component {
  btnClickedHandler() {
    const { value, clicked } = this.props;
    clicked(value);
  }
  constructor(props) {
    super(props);
    this.btnPostHandler = this.btnPostHandler.bind(this);
  }

  btnPostHandler() {
    const { data, PostData } = this.props;
    PostData(data);
  }

  render() {
    const { permissions } = this.props;
    const { loading } = this.props;
    const { data } = this.props;
    const { postedData } = this.props;
    return (
      <div className="center">
        {loading === true && postedData?.docno === data?.docno ? (
          <button className="gridbtn p-0">
            <ClipLoader color="#ffffff" size={25} />
          </button>
        ) : (
          <>
            {permissions?.canAdd === true ? (
              <button onClick={this.btnPostHandler} className="gridbtn p-0">
                Post
              </button>
            ) : (
              ''
            )}
          </>
        )}
      </div>
    );
  }
}
export default Posting;
